import axios from 'axios';

const MODES =  {
    development : 'development',
    production : 'production',
    test : 'test',
};

let baseURL;
switch(process.env.NODE_ENV) {
    case MODES.test:
    case MODES.development:
        baseURL = 'http://admin.local.european-beer-star.de';
        break;
    case MODES.production:
    default:
        baseURL = 'https://admin2023.european-beer-star.de/';
        break;
}

export default axios.create({
    baseURL
});